import { ruleOutcomeTypes } from "../redux/Types";
import { host_basename } from "../App";

export const activityLimitActions = (abuseFlag) => {
  if (abuseFlag == ruleOutcomeTypes.LOGOUT ||
      abuseFlag == ruleOutcomeTypes.DEACTIVATE)
    // Logout user
    window.location.replace(`${host_basename}/signin`);
}